import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, X } from 'lucide-react';
import DateFilter from './DateFilter';
import KanbanBoard from './KanbanBoard';
import TaskDetailModel from './TaskDetailModel';
import DashboardHeader from './DashboardHeader';

const selectStyle = { padding: '8px 10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '13px', background: '#fff', minWidth: '200px' };
const labelStyle = { fontSize: '11px', fontWeight: '700', color: '#64748b', marginBottom: '4px', display: 'block' };

// Item #3: Global Filters (the shared Company+SPOC+dates component) removed
// from Task pages entirely — this is a plain, page-specific Company filter
// plus the single combined Assigned/Reassigned Date filter.
const RecruiterTasks = ({ tasks, filterState, onFilterChange, filterCondition, onUpdateTaskStatus, currentUser, onLogout }) => {
    const navigate = useNavigate();
    const [selectedTask, setSelectedTask] = useState(null);
    const [filterCompany, setFilterCompany] = useState('');
    const companyOptions = useMemo(() => Array.from(new Set(tasks.map(t => t.company).filter(Boolean))).sort(), [tasks]);

    return (
        <div style={{ fontFamily: 'Inter, sans-serif', background: '#f4f6f8', minHeight: '100vh', padding: '20px', boxSizing: 'border-box' }}>
            <DashboardHeader user={currentUser} titleText="Tasks" onLogout={onLogout} />

            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <button
                    onClick={() => navigate('/recruiter')}
                    style={{
                        display: 'flex', alignItems: 'center', gap: '6px', background: '#fff',
                        border: '1px solid #e2e8f0', padding: '8px 14px', borderRadius: '6px',
                        fontSize: '13px', fontWeight: '600', color: '#334155', cursor: 'pointer'
                    }}
                >
                    <ArrowLeft size={14} /> Back to Dashboard
                </button>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#0f172a' }}>Tasks</h2>
            </div>

            <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '12px 14px', marginBottom: '16px', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: '12px' }}>
                    <div>
                        <label style={labelStyle}>Company</label>
                        <select style={selectStyle} value={filterCompany} onChange={(e) => setFilterCompany(e.target.value)}>
                            <option value="">All Companies</option>
                            {companyOptions.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                    </div>
                    {filterCompany && (
                        <button
                            type="button"
                            onClick={() => setFilterCompany('')}
                            style={{ display: 'flex', alignItems: 'center', gap: '4px', background: '#fee2e2', color: '#b91c1c', border: 'none', padding: '9px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
                        >
                            <X size={12} /> Clear
                        </button>
                    )}
                </div>
                <div style={{ maxWidth: '680px' }}>
                    {/* Item #3: one combined filter, matches Assigned Date OR Reassigned Date. */}
                    <label style={labelStyle}>Date (Assigned or Reassigned)</label>
                    <DateFilter dateField={['assigned_date', 'reassigned_date']} initialValue={filterState} onFilterChange={onFilterChange} />
                </div>
            </div>

            <KanbanBoard
                tasks={tasks}
                filterCondition={(t) => filterCondition(t) && (!filterCompany || t.company === filterCompany)}
                onSelectTask={setSelectedTask}
                isRecruiter={true}
                onUpdateTaskStatus={onUpdateTaskStatus}
            />
            <TaskDetailModel task={selectedTask} onClose={() => setSelectedTask(null)} onUpdateTaskStatus={onUpdateTaskStatus} currentUser={currentUser} />
        </div>
    );
};

export default RecruiterTasks;